import { createAction } from 'react-async-client';

import {
    OPEN_MODAL_REQUEST,

    GET_REQUEST_LIST,
    GET_REQUEST_COUNTERS,
    SET_REQUEST_LIST_SORT,
    SET_REQUEST_LIST_SELECTED,
    SET_REQUEST_LIST_PAGINATION
} from 'constants/actionTypes'

export const openModalRequest = createAction(OPEN_MODAL_REQUEST);

export const getRequestList = createAction(GET_REQUEST_LIST);
export const getRequestCounters = createAction(GET_REQUEST_COUNTERS);
export const setRequestListSort = createAction(SET_REQUEST_LIST_SORT);
export const setRequestListSelected = createAction(SET_REQUEST_LIST_SELECTED);
export const setRequestListPagination = createAction(SET_REQUEST_LIST_PAGINATION);
